import React, { Component } from "react";
import styled from "styled-components";
import LogoImage from "../../assets/logo.svg";
import ShoppingCartImage from "../../assets/shoppingcart.svg";
import ArrowIcon from "../../assets/arrow.svg";
import { Query } from "@apollo/client/react/components";
import navQuery from "../../apollo/queries/navQuery";
import LoadingSpinner from "../LoadingSpinner";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import NavCart from "./NavCart";
import { mapStateToProps } from "../../redux/store";
import { changeCurrency } from "../../redux/features/currencySlice";
import { withRouter } from "../../withRouter";
const Container = styled.header`
  min-height: 80px;
  position: relative;
`;
const Nav = styled.nav`
  position: relative;
  padding: 0 0.75rem;
  min-height: 80px;
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  & > * {
    flex: 1;
  }
`;
const Categories = styled.ul`
  display: flex;
  list-style: none;
  gap: 5px;
  .active {
    color: #5ece7b;
    border-bottom: 2px solid #5ece7b;
    font-weight: 600;
  }
`;
const Category = styled(NavLink)`
  font-size: 0.75rem;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  height: 80px;
  font-weight: 400;
  padding: 1em;
  cursor: pointer;
  position: relative;
  z-index: 200;
  @media (hover: hover) {
    &:hover {
      border-bottom: 2px solid #5ece7b;
    }
  }
  @media screen and (min-width: 768px) {
    font-size: 1rem;
  }
`;
const Logo = styled.div`
  display: flex;
  justify-content: center;
  display: none;
  @media screen and (min-width: 768px) {
    display: flex;
  }
`;
const Image = styled.img`
  height: 100%;
  object-fit: cover;
`;
const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  position: relative;
`;
const ActionsWrapper = styled.div`
  position: relative;
  display: flex;
  gap: 20px;
  padding: 0.75rem;
`;
const Currencies = styled.div``;
const CurrentCurrency = styled.div`
  display: flex;
  gap: 10px;
  cursor: pointer;
  position: relative;
  z-index: 200;
`;
const SelectedCurrency = styled.div`
  font-size: 1.125rem;
  font-weight: 500;
`;
const CurrencySwitcher = styled.img`
  transform: ${({ currencyToggle }) =>
    currencyToggle ? "rotate(-180deg)" : "rotate(0)"};
`;
const CurrenciesList = styled.div`
  display: ${({ currencyToggle }) => (currencyToggle ? "block" : "none")};
  position: absolute;
  background-color: white;
  z-index: 110;
  width: 100%;
  left: 0;
  right: 0;
  top: 100%;

  box-shadow: 0px 4px 35px 0px #a8acb030;
`;
const Currency = styled.div`
  text-transform: uppercase;
  padding: 0.5rem;
  width: 100%;
  font-size: 1.125rem;
  font-weight: 500;
  cursor: pointer;
  @media (hover: hover) {
    &:hover {
      background-color: #eeeeee;
    }
  }
`;
const ShoppingCart = styled.div`
  cursor: pointer;
  position: relative;
  z-index: 200;
  &::after {
    content: "${({ count }) => count}";
    display: ${({ count }) => (count > 0 ? "block" : "none")};
    position: absolute;
    top: -10px;
    right: -10px;
    font-size: 14px;
    font-weight: bold;
    text-align: center;
    vertical-align: middle;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    color: white;
    background-color: #1d1f22;
  }
`;
const Overlay = styled.div`
  display: ${({ cartToggle }) => (cartToggle ? "block" : "none")};
  height: calc(100vh - 80px);
  overflow-y: hidden;
  width: 100%;
  z-index: 99;
  background-color: rgba(57, 55, 72, 0.22);
  position: absolute;
  top: 100%;
`;
const InvisibleOverlay = styled.div`
  display: ${({ toggler }) =>
    toggler.cartToggle || toggler.currencyToggle ? "block" : "none"};
  top: 0;
  position: absolute;
  height: 100vh;
  width: 100%;
  z-index: 100;
`;
const Error = styled.h1`
  text-align: center;
`;
class Navbar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currencyToggle: false,
      cartToggle: false,
      route: this.props.location.pathname,
    };
  }
  componentDidUpdate() {
    if (this.state.cartToggle) {
      document.body.style.overflow = "hidden";
    }
    if (!this.state.cartToggle) {
      document.body.style.overflow = "unset";
    }
    if (this.state.route !== this.props.location.pathname) {
      this.setState({
        currencyToggle: false,
        cartToggle: false,
        route: this.props.location.pathname,
      });
    }
  }
  render() {
    return (
      <Container>
        <Query query={navQuery}>
          {({ loading, error, data }) => {
            if (loading) return <LoadingSpinner />;
            if (error) return <Error>Server error</Error>;
            Object.keys(this.props.currencyState).length === 0 &&
              this.props.dispatch(changeCurrency(data.currencies[0]));
            const totalProductsQuantity = this.props.cartState.reduce(
              (prev, product) => (prev += product.quantity),
              0
            );

            return (
              <Nav>
                <Categories>
                  {data.categories.map((category, index) => {
                    if (index === 0)
                      return (
                        <Category
                          to="/"
                          key={category.name}
                          activeclassname="active"
                        >
                          {category.name}
                        </Category>
                      );
                    else
                      return (
                        <Category
                          to={`/${category.name}`}
                          key={category.name}
                          activeclassname="active"
                        >
                          {category.name}
                        </Category>
                      );
                  })}
                </Categories>
                <Logo>
                  <Image src={LogoImage} />
                </Logo>
                <Actions>
                  <ActionsWrapper>
                    <Currencies>
                      <CurrentCurrency
                        onClick={() =>
                          this.setState({
                            currencyToggle: !this.state.currencyToggle,
                            cartToggle: false,
                          })
                        }
                      >
                        <SelectedCurrency>
                          {this.props.currencyState.symbol}
                        </SelectedCurrency>
                        <CurrencySwitcher
                          currencyToggle={this.state.currencyToggle}
                          src={ArrowIcon}
                        />
                      </CurrentCurrency>
                      <CurrenciesList
                        currencyToggle={this.state.currencyToggle}
                      >
                        {data.currencies.map((currency) => (
                          <Currency
                            key={currency.label}
                            onClick={() => {
                              this.props.dispatch(changeCurrency(currency));
                              this.setState({ currencyToggle: false });
                            }}
                          >
                            {currency.symbol} {currency.label}
                          </Currency>
                        ))}
                      </CurrenciesList>
                    </Currencies>
                    <ShoppingCart
                      count={totalProductsQuantity}
                      onClick={() =>
                        this.setState({
                          cartToggle: !this.state.cartToggle,
                          currencyToggle: false,
                        })
                      }
                    >
                      <Image src={ShoppingCartImage} />
                    </ShoppingCart>
                  </ActionsWrapper>
                </Actions>
                <NavCart
                  cartToggle={this.state.cartToggle}
                  totalProductsQuantity={totalProductsQuantity}
                />
              </Nav>
            );
          }}
        </Query>
        <Overlay cartToggle={this.state.cartToggle} />
        <InvisibleOverlay
          toggler={{
            cartToggle: this.state.cartToggle,
            currencyToggle: this.state.currencyToggle,
          }}
          onClick={() =>
            this.setState({ cartToggle: false, currencyToggle: false })
          }
        />
      </Container>
    );
  }
}

export default withRouter(connect(mapStateToProps)(Navbar));
